import { createUnavailablePublicMarketSource, MultiSourcePublicMarketProvider } from "./multiSourceMarketProvider.ts";
import { NehnutelnostiPublicSandboxAdapter } from "./sandbox/NehnutelnostiPublicSandboxAdapter.ts";

export const PUBLIC_MARKET_SOURCE_POLICY = [
  {
    id: "nehnutelnosti-sk",
    name: "Nehnuteľnosti.sk",
    blocker: "Vyžaduje zmluvne povolené API Trhové reporty alebo schválený feed."
  },
  {
    id: "reality-sk",
    name: "Reality.sk",
    blocker: "Vyžaduje schválený API/feed prístup od prevádzkovateľa."
  },
  {
    id: "bazos-sk",
    name: "Bazoš.sk",
    blocker: "Neoficiálne aplikácie zobrazujúce inzeráty sú podľa podmienok portálu zakázané."
  },
  {
    id: "topreality-sk",
    name: "TopReality.sk",
    blocker: "Vyžaduje schválený API/feed prístup od prevádzkovateľa."
  }
] as const;

export const guardedPublicMarketProvider = new MultiSourcePublicMarketProvider(
  PUBLIC_MARKET_SOURCE_POLICY.map((source) =>
    createUnavailablePublicMarketSource(source.id, source.name, source.blocker)
  )
);

export const configuredPublicMarketProvider = import.meta.env.VITE_MARKET_PUBLIC_SANDBOX === "true"
  ? new MultiSourcePublicMarketProvider([new NehnutelnostiPublicSandboxAdapter()])
  : guardedPublicMarketProvider;
